import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { SuiBadgeComponent } from '@stride-ui/components';
import { TranslateModule } from '@ngx-translate/core';

export enum ValueBadgeVariant {
  Success = 'success',
  Error = 'error',
}

@Component({
  selector: 'tnq-key-value',
  imports: [TranslateModule, SuiBadgeComponent],
  templateUrl: './key-value.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './key-value.component.scss',
})
export class KeyValueComponent {
  key = input.required<string>();
  value = input<string | null>();
  variant = input<'even' | 'wide'>('wide');
  hasSeparationLine = input<boolean>(false);
  badgeValue = input<{
    badgeVariant: ValueBadgeVariant;
    value: string | null;
  }>();
  ValueBadgeVariant = ValueBadgeVariant;

  get stringValue(): string {
    if (this.value()) {
      return this.value() || '-';
    }
    if (this.badgeValue()) {
      return this.badgeValue()?.value || '-';
    }
    return '-';
  }

  get badgeVariant(): ValueBadgeVariant | undefined {
    return this.badgeValue()?.badgeVariant || undefined;
  }
}
